// AddLeadModal.jsx
import React, { useState } from "react";
import EnterLeadDetails from "./EnterLeadDetails";
import Review from "./Review";
import SelectCategory from "./SelectCategory";
import SelectProduct from "./SelectProduct";
import Stepper from "../../../components/common/Stepper";

const AddLeadModal = ({ isOpen, onClose, preselectedProduct = null, preSelectedCategory = null, preSelectedSubCategory = null }) => {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(preSelectedCategory);
  const [selectedSubCategory, setSelectedSubCategory] = useState(preSelectedSubCategory);
  const [selectedProduct, setSelectedProduct] = useState(preselectedProduct);

  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState();

  const isShortFlow = Boolean(preselectedProduct || preSelectedCategory || preSelectedSubCategory);

  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);
  const handleData = (values, state, city) => {
    setSelectedState(state);
    setSelectedCity(city);
    setFormData((prev) => ({ ...prev, ...values }));
  };

  if (!isOpen) return null;

  const stepList = isShortFlow
    ? [
        {
          title: "Details",
          component: (
            <EnterLeadDetails
              onCloseModal={onClose}
              onNext={nextStep}
              onUpdate={handleData}
              initialValues={formData}
            />
          ),
        },
        {
          title: "Review",
          component: (
            <Review
              onBack={prevStep}
              onClose={onClose}
              data={formData}
              category={selectedCategory}
              subCategory={selectedSubCategory}
              product={selectedProduct}
              selectedState={selectedState}
              selectedCity={selectedCity}
            />
          ),
        },
      ]
    : [
        {
          title: "Details",
          component: (
            <EnterLeadDetails
              onCloseModal={onClose}
              onNext={nextStep}
              onUpdate={handleData}
              initialValues={formData}
            />
          ),
        },
        {
          title: "Category",
          component: (
            <SelectCategory
              onNext={nextStep}
              onBack={prevStep}
              onUpdate={(_cat) => {
                console.log("Selected category:", _cat);
                setSelectedCategory(_cat);
                if (_cat?.category_id !== selectedCategory?.category_id) {
                  setSelectedSubCategory(null);
                  setSelectedProduct(null);
                }
              }}
              selectedCategory={selectedCategory}
            />
          ),
        },
        {
          title: "Product",
          component: (
            <SelectProduct
              onNext={nextStep}
              onBack={prevStep}
              onUpdate={(_val, productType) => {
                if (productType === "sub_category") {
                  setSelectedSubCategory(_val);
                } else {
                  setSelectedProduct(_val);
                }
                console.log("Selected product:", productType, _val);
              }}
              selectedCategory={selectedCategory}
            />
          ),
        },
        {
          title: "Review",
          component: (
            <Review
              onBack={prevStep}
              onClose={onClose}
              data={formData}
              category={selectedCategory}
              subCategory={selectedSubCategory}
              product={selectedProduct}
              selectedState={selectedState}
              selectedCity={selectedCity}
            />
          ),
        },
      ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="flex flex-col bg-white w-[min(55rem,_90%)] rounded-xl shadow-lg p-6 h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-3">Add New Leads</h2>
        <Stepper tabList={stepList} tabIndex={step} 
          containerClassName="flex flex-col flex-1"
          childrenClassName="flex flex-col flex-1"
        />
      </div>
    </div>
  );
};

export default AddLeadModal;
